import React from 'react';

const CatalogoPisoVinilicoLVT = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Modelos Piso Vinílico LVT Autoadherible</h2>
          <p>Descubre nuestra amplia gama de modelos de piso vinílico LVT autoadherible, diseñados para combinar funcionalidad y estética. 
            Cada modelo ofrece una apariencia realista similar a la madera o piedra natural, con una variedad de colores y texturas que se adaptan a cualquier espacio.</p>
            <p>Explora los modelos disponibles y elige el diseño ideal para transformar tus espacios. ¡Contáctanos para más información o una cotización personalizada!</p>
        </div>
        <div className="row gx-5 mt-n1-9 text-center">
          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="300ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-modelo-tabaco.jpg" 
                  alt="piso vinilico gris" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Tabaco</h5>
                  <span>Modelo: 6197</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="450ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-modelo-teka.jpg" 
                  alt="piso vinilico teka" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Teka</h5>
                  <span>Modelo: 795-1</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="600ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-modelo-madera.jpg" 
                  alt="piso vinilico madera" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Madera</h5>
                  <span>Modelo: 9917</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="600ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-modelo-gris-2.jpg" 
                  alt="piso vinilico otro modelo" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Gris</h5>
                  <span>Modelo: 9903</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-md right-10 top-35 border-secondary-color d-none d-lg-block"></div>
    </section>
  );
};

export default CatalogoPisoVinilicoLVT;
